var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
	'redraw-progress',
	{ 'is-fixed': _vm.isFixed }
]},[_c('div',{staticClass:"redraw-progress__inner"},[_c('v-ons-progress-circular',{attrs:{"indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }